enum Type {
  Data = 'data',
  Free = 'free',
  Vaccine = 'vaccine',
  Virus = 'virus',
}

export default Type;
